// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React, { useContext } from 'react';
import { Col, Row } from '@op/opds.opux';
import RedirectButton from './RedirectButton';
import { ContextWrapper } from '../context/ContextWrapper';
import message from '../messages';
import CancelButton from './CancelButton';

interface NavigationButtonsProps {
    backPath?: string;
    cancelEnabled: boolean;
    continuePath?: string;
    continueProcess?: any;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
    backPath,
    cancelEnabled,
    continuePath,
    continueProcess,
}) => {
    const { contractData, updateInformation } = useContext(ContextWrapper);

    return (
        <Row around="sm" center="sm">
            {backPath && (
                <Col sm={3} className="navigationColumn" data-testid="backButton">
                    <RedirectButton
                        className="navigation-button"
                        id="backButton"
                        to={backPath}
                        onClick={() => {
                            window.scrollTo(0, 0);
                            return true;
                        }}
                    >
                        {message('back')}
                    </RedirectButton>
                </Col>
            )}
            {cancelEnabled && (
                <Col sm={3} className="navigationColumn">
                    <CancelButton />
                </Col>
            )}
            {continuePath && (
                <Col sm={3} className="navigationColumn" data-testid="continueButton">
                    <RedirectButton
                        className="navigation-button"
                        id="continueButton"
                        primary
                        to={continuePath}
                        onClick={() => continueProcess(contractData, updateInformation)}
                    >
                        {message('continueBtn')}
                    </RedirectButton>
                </Col>
            )}
        </Row>
    );
};

export default NavigationButtons;
